import { Button, ClickEvent, Layout, SlideoutDecorator, Snackbar } from "@mcleod/components";
import { AutogenLayoutInvoiceCustomerCrossReference } from "./autogen/AutogenLayoutInvoiceCustomerCrossReference";
import { Api } from "@mcleod/core/src/Api";
import { CustomerQuickInfo } from "@mcleod/ar/src/CustomerQuickInfo";
import { Alignment } from "@mcleod/core/src/constants/Alignment";

interface InvoiceCustomerCrossReferenceProps {
    customerEdiloc: string;
    version: string;
    partnerId: string;
    customerId: string;
    ediBillingId: string;
    doAfterSlideOut?: () => Promise<void>;
}

export class InvoiceCustomerCrossReference extends AutogenLayoutInvoiceCustomerCrossReference {
    private _originalCustomerEdiloc: string;
    saveButtonClicked: boolean = false;
    partnerLocationNeeded: boolean = false;
    static showSlideout(props: InvoiceCustomerCrossReferenceProps): void {
        const layout = Layout.getLayout("lme/datafusion/InvoiceCustomerCrossReference") as InvoiceCustomerCrossReference;
        layout.originalCustomerEdiloc = props.customerEdiloc;
        const saveButton = new Button({
            id: "buttonSave",
            caption: "Save",
            backgroundColor: "primary",
            color: "primary.reverse",
            minWidth: 128,
            borderWidth: 0,
            rowBreak: false,
            onClick: async (event: ClickEvent) => {
                try {
                    layout.partnerLocationNeeded = false;
                    if (layout.originalCustomerEdiloc !== layout.textboxEdiLocation.text) {
                        if (layout.textboxEdiLocation.text !== undefined && layout.textboxEdiLocation.text !== null && layout.textboxEdiLocation.text !== "") {
                            layout.saveButtonClicked = true;
                            saveButton.busy = true;
                            await Api.post("lme/datafusion/new-edi-customer-xref", {
                                partner_id: props.partnerId,
                                version: props.version,
                                customer_id: props.customerId,
                                new_customer_text: layout.textboxEdiLocation.text,
                                billing_id: props.ediBillingId
                            });
                        } else {
                            layout.partnerLocationNeeded = true;
                            Snackbar.showWarningSnackbar("Partner location code must be entered.");
                        }
                    }
                } catch (error) {
                    Snackbar.showWarningSnackbar("Error saving cross-reference.");
                } finally {
                    saveButton.busy = false;
                    if (!layout.partnerLocationNeeded) {
                        await layout.slideOut();
                    }

                }
            }
        });
        const decorator = new SlideoutDecorator({
            layout: layout,
            width: window.innerWidth * 0.30,
            title: "DataFusion Bill-to Cross Reference",
            fillVerticalSpace: true,
            onClose: () => {
                decorator.slideOut();
            },
            layoutLoadListeners: async () => {
                await layout.mainDataSource.search({ version: props.version, partner_id: props.partnerId, customer_id: props.customerId });
                layout.setupQuickInfo(layout);
            },
            doAfterSlideOut: async () => {
                // Perform any actions needed after the slide-out is closed
                if (layout.saveButtonClicked) {
                    await props.doAfterSlideOut?.();
                }
            },
            addlComponents: [saveButton]
        });
    }

    public get originalCustomerEdiloc(): string {
        return this._originalCustomerEdiloc;
    }

    public set originalCustomerEdiloc(value: string) {
        this._originalCustomerEdiloc = value;
    }

    private setupQuickInfo(layoutInput: InvoiceCustomerCrossReference) {
        layoutInput.textboxCustomerId.tooltipDynamicContent = async () => {
            const customerID = layoutInput.mainDataSource.activeRow?.get("customer_id");
            const layout = await Layout.getLoadedLayout("lme/ar/CustomerQuickInfo") as CustomerQuickInfo;
            await layout.sourceCustomer?.search({ id: customerID });
            return layout;
        };
    }
}
